export const LocalStorageKey = "statBlocks";
export const StatBlockTypes = {
    monster: 'monster',
    default: 'default'
};